import closeIcon from "../../images/png/close.png"

const ImageModal = ({ image, isActive, closeImg }) => {

    return (
        isActive && (
            <div style={{
                position: "fixed",
                zIndex: 50,
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                backgroundColor: "#ffffff10",
                display: "flex",
                justifyContent: "center",
                alignItems: 'center'
            }}>

                <div style={{
                    backgroundColor: "#fff",
                    position: "relative",
                    borderRadius: "8px",
                    border: "1px solid"
                }}>
                    <a href={image} target="_blank">
                    <img style={{maxWidth: "600px", maxHeight: "520px", objectFit: "contain",  borderRadius: "8px"}} src={image}/>
                    </a>

                    <div style={{
                        position: "absolute",
                        right: "-13px",
                        top: "-12px",
                        cursor: "pointer"
                    }}>
                        <img onClick={() => closeImg()} style={{ width: "30px", height: "30px", objectFit: "contain" }} src={closeIcon} />
                    </div>
                </div>
            </div>

        )
    )
}

export default ImageModal